<template>
  <v-data-table-server
    :headers="headers"
    :items="loading ? [] : searchResults"
    :items-per-page-options="[10, 25, 50, 100]"
    :loading="loading"
    :items-length="totalSearchResults"
    :page="page"
    @update:page="$emit('update:page', $event)"
    :items-per-page="rows"
    @update:items-per-page="$emit('update:rows', $event)"
    :page-text="searchTotalLoading ? '{0}-{1} of Loading...' : '{0}-{1} of {2}'"
    :no-data-text="$t('search.noData')"
    :loading-text="$t('search.loadingText')"
  >
    <template #[`item.name`]="{ item }">
      <slot name="item.name" :item="item">
        {{ item.name }}
      </slot>
    </template>
    <template #[`item.translations`]="{ item }">
      <slot name="item.translations" :item="item">
        {{ item.translations }}
      </slot>
    </template>

    <template #[`item.matches`]="{ item }">
      <slot name="item.matches" :item="item">
        <div
          v-for="(match, index) in item.matches"
          :key="index"
          v-html="match"
        ></div>
      </slot>
    </template>
  </v-data-table-server>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { DataTableHeader } from 'vuetify';
import { DictionarySearchRow } from '@oare/types';

export default defineComponent({
  props: {
    searchResults: {
      type: Array as PropType<DictionarySearchRow[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    totalSearchResults: {
      type: Number,
      required: true,
    },
    searchTotalLoading: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },
    rows: {
      type: Number,
      default: 10,
    },
    headers: {
      type: Array as PropType<DataTableHeader[]>,
      required: true,
    },
  },
  emits: {
    'update:page': (_page: number) => true,
    'update:rows': (_rows: number) => true,
  },
});
</script>
